import { forwardRef, type ReactNode } from "react";

interface PanelProps {
	children: ReactNode;
	title?: string;
}

export const Panel = forwardRef<HTMLDivElement, PanelProps>(({ children, title }, ref) => {
	return (
		<div ref={ref} className="aa-panel">
			{title && (
				<div className="aa-panel__header">
					<h3 className="h5">{title}</h3>
				</div>
			)}
			<div className="aa-panel__body">{children}</div>
		</div>
	);
});

Panel.displayName = "Panel";
